import { useRouter } from 'next/router'

import { COBRANDING_PARTNER_COOKIE_KEY } from '@/constants'
import Cookies from 'js-cookie'
import { useGetQueryParam } from 'src/hooks/useGetQueryParam'

import { CobrandingNewPartners } from './useGetCobrandingNewPartners'

const audiencePaths = [
  '/life/quick-online-quote/',
  '/life/indexed-universal-life/',
]

export const useForbesHeaderNavbar = () => {
  const { asPath } = useRouter()
  const queryUtmParams = useGetQueryParam('utm_term')

  const pathnameWithoutQuery = asPath.split('?')[0]
  const isValidAudiencePath = audiencePaths.includes(pathnameWithoutQuery)

  const isForbesUtmTerm = queryUtmParams === '1955282'

  const isEnabled = isValidAudiencePath && isForbesUtmTerm

  if (isEnabled) {
    Cookies.set(COBRANDING_PARTNER_COOKIE_KEY, CobrandingNewPartners.Forbes, {
      expires: 365,
    })
  }

  return isEnabled
}
